// GroupOrContactProfileModal.js
import React, { useEffect, useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Avatar,
    Typography,
    IconButton,
    Button,
    Divider,
    TextField,
    Menu,
    MenuItem
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import PersonIcon from '@mui/icons-material/Person';
import CallIcon from '@mui/icons-material/Call';
import SaveIcon from '@mui/icons-material/Save';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import axios from "axios";
import { BASE_URL_MESSENGER_API, URL_CONTACT_AVATAR, URL_GROUP_AVATAR } from "../../Const";
import {MessengerUserRepository} from "../../Repository/messenger/MessengerUserRepository";

export const GroupOrContactProfileModal = ({
                                               open,
                                               onClose,
                                               data,
                                               currentUserId,
                                               onCall
                                           }) => {
    const isGroup = !!data?.id && !!data?.title;
    const [members, setMembers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [editing, setEditing] = useState(false);
    const [groupTitle, setGroupTitle] = useState(data?.title || "");
    const [avatarFile, setAvatarFile] = useState(null);
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedUser, setSelectedUser] = useState(null);

    useEffect(() => {
        if (isGroup && data?.id && open) {
            setLoading(true);
            axios.get(`${BASE_URL_MESSENGER_API}group/member/${data.id}`, {
                headers: {
                    Authorization: `Bearer ${MessengerUserRepository.getUserToken()}`
                }
            })
                .then(res => {
                    if (res.data.code === 200) {
                        setMembers(res.data.data.memberships.map(m => ({ ...m.contact, role: m.role })));
                    }
                })
                .catch(console.error)
                .finally(() => setLoading(false));
        }
        setGroupTitle(data?.title || "");
    }, [data, open]);

    const isAdmin = members.find(m => m.id === currentUserId)?.role === "admin";

    const handleChangeRole = (memberId, role) => {
        axios.put(`${BASE_URL_MESSENGER_API}group/member`, {
            group_id: data.id,
            member_id: memberId,
            role
        }, {
            headers: {
                Authorization: `Bearer ${MessengerUserRepository.getUserToken()}`
            }
        })
            .then(() => {
                setMembers(prev => prev.map(m => m.id === memberId ? { ...m, role } : m));
                setAnchorEl(null);
            })
            .catch(console.error);
    };

    const handleDelete = (memberId) => {
        axios.delete(`${BASE_URL_MESSENGER_API}group/member/${data.id}/${memberId}`, {
            headers: {
                Authorization: `Bearer ${MessengerUserRepository.getUserToken()}`
            }
        })
            .then(() => {
                setMembers(prev => prev.filter(m => m.id !== memberId));
            })
            .catch(console.error);
    };

    const saveGroupTitle = () => {
        axios.put(`${BASE_URL_MESSENGER_API}groups/${data.id}`, {
            title: groupTitle
        }, {
            headers: {
                Authorization: `Bearer ${MessengerUserRepository.getUserToken()}`
            }
        })
            .then(() => setEditing(false))
            .catch(console.error);
    };

    const uploadAvatar = () => {
        const formData = new FormData();
        formData.append("file", avatarFile);
        formData.append("group_id", data.id);
        axios.post(`${BASE_URL_MESSENGER_API}uploadGroupAvatar`, formData, {
            headers: {
                Authorization: `Bearer ${MessengerUserRepository.getUserToken()}`,
                'Content-Type': 'multipart/form-data'
            }
        })
            .then(() => {
                alert("آواتار با موفقیت به‌روزرسانی شد.");
                window.location.reload();
            })
            .catch(console.error);
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle style={{ display: "flex", alignItems: "center", justifyContent: "space-between", direction: "rtl" }}>
                <div>{isGroup ? "پروفایل گروه" : "پروفایل کاربر"}</div>
                {isAdmin && isGroup && (
                    <IconButton onClick={() => setEditing(!editing)} size="large">
                        <EditIcon color="primary" />
                    </IconButton>
                )}
            </DialogTitle>
            <DialogContent style={{ textAlign: "center", direction: "rtl" }}>
                <div style={{ position: "relative" }}>
                    <Avatar
                        src={(isGroup ? URL_GROUP_AVATAR : URL_CONTACT_AVATAR) + (data.avatar || "")}
                        style={{ width: 100, height: 100, margin: "0 auto" }}
                    >
                        {!data.avatar && <PersonIcon style={{ fontSize: 48 }} />}
                    </Avatar>
                    {isAdmin && editing && (
                        <>
                            <input type="file" accept="image/*" onChange={(e) => setAvatarFile(e.target.files[0])} />
                            <Button onClick={uploadAvatar} size="small" variant="outlined" style={{ marginTop: 8 }}>آپلود آواتار</Button>
                        </>
                    )}
                </div>

                {isGroup && editing ? (
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginTop: 12 }}>
                        <TextField
                            value={groupTitle}
                            onChange={(e) => setGroupTitle(e.target.value)}
                            variant="outlined"
                            size="small"
                            style={{ marginLeft: 8 }}
                        />
                        <IconButton onClick={saveGroupTitle} size="large">
                            <SaveIcon color="primary" />
                        </IconButton>
                    </div>
                ) : (
                    <Typography variant="h6" style={{ marginTop: 12 }}>{data.name || data.title}</Typography>
                )}

                {!isGroup && (
                    <>
                        <Divider style={{ margin: "12px 0" }} />
                        <Typography variant="body2" color="textSecondary">شماره تماس</Typography>
                        <Typography variant="body1" style={{ direction: "ltr", marginBottom: 8 }}>{data.number}</Typography>
                        <Button
                            variant="outlined"
                            color="primary"
                            startIcon={<CallIcon />}
                            onClick={() => onCall(data.number)}
                        >
                            تماس
                        </Button>
                    </>
                )}

                {isGroup && (
                    <>
                        <Divider style={{ margin: "12px 0" }} />
                        <Typography variant="subtitle1">اعضای گروه</Typography>
                        {loading ? <Typography>در حال بارگذاری...</Typography> : members.map(member => (
                            <div
                                key={member.id}
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    padding: "6px 0"
                                }}
                            >
                                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                    <Avatar src={URL_CONTACT_AVATAR + (member.avatar || "")} style={{ width: 36, height: 36 }}>
                                        {!member.avatar && <PersonIcon style={{ fontSize: 20 }} />}
                                    </Avatar>
                                    <div style={{ textAlign: "right" }}>
                                        <Typography>{member.name}</Typography>
                                        <Typography variant="caption" color="textSecondary">{member.role}</Typography>
                                        {member.bio && <Typography variant="caption" color="textSecondary"> - {member.bio}</Typography>}
                                    </div>
                                </div>
                                {isAdmin && member.id !== currentUserId && (
                                    <div>
                                        <IconButton size="small" onClick={(e) => { setSelectedUser(member); setAnchorEl(e.currentTarget); }}>
                                            <MoreVertIcon />
                                        </IconButton>
                                    </div>
                                )}
                            </div>
                        ))}
                        <Menu
                            anchorEl={anchorEl}
                            open={Boolean(anchorEl)}
                            onClose={() => setAnchorEl(null)}
                        >
                            <MenuItem onClick={() => handleChangeRole(selectedUser.id, 'admin')}>ارتقا به مدیر</MenuItem>
                            <MenuItem onClick={() => handleChangeRole(selectedUser.id, 'member')}>تغییر به عضو</MenuItem>
                            <MenuItem onClick={() => handleDelete(selectedUser.id)}>حذف از گروه</MenuItem>
                        </Menu>
                    </>
                )}
            </DialogContent>
        </Dialog>
    );
};
